import React from 'react'
import moment from 'moment'
import { Segment, Header, Label, Icon, Message, Grid } from 'semantic-ui-react'
import I18n from '../../../../../../i18n'

const dateLabel = value => value ? moment(value).format('DD/MM/YYYY') : '—';

/**
 * Lo que hay que saber de un vistazo: qué plan tiene HOY el profesor, hasta cuándo
 * llega su acceso y qué fecha de cobro tiene puesta Stripe.
 *
 * Las dos fechas se muestran juntas a propósito. Vivían en pantallas distintas (el
 * panel y Stripe), así que un descuadre entre lo concedido y lo que se va a cobrar
 * solo se descubría cuando el profesor recibía el cargo.
 */
const ProLicenseStatus = ({ overview }) => {

  if (!overview) return null;

  const { plan, maxStudents, coverageEnd, stripe } = overview;

  const isFree = !overview.current;

  const misaligned = stripe && stripe.hasSubscription && stripe.aligned === false;

  return (
    <Segment>

      <Header as="h3">{ I18n.t('pro.info.status.title') }</Header>

      <Grid columns={ 3 } stackable>

        <Grid.Column>
          <Label size="large" color={ isFree ? 'grey' : 'teal' }>
            { plan || 'Free' }
          </Label>
          <p style={{ marginTop: '0.5rem' }}>{ I18n.t('pro.info.status.maxStudents', { maxStudents }) }</p>
        </Grid.Column>

        <Grid.Column>
          <strong>{ I18n.t('pro.info.status.coverageEnd') }</strong>
          <p>
            { isFree
              ? I18n.t('pro.info.status.noLicense')
              : dateLabel(coverageEnd) }
          </p>
        </Grid.Column>

        <Grid.Column>
          <strong>{ I18n.t('pro.info.status.stripe') }</strong>
          {
            !stripe && <p>{ I18n.t('pro.info.status.noCustomer') }</p>
          }
          {
            stripe && stripe.error && <p>{ I18n.t('pro.info.status.stripeError', { error: stripe.error }) }</p>
          }
          {
            stripe && !stripe.error && !stripe.hasSubscription && <p>{ I18n.t('pro.info.status.noSubscription') }</p>
          }
          {
            stripe && stripe.hasSubscription && (
              <p>
                { I18n.t(stripe.trialing ? 'pro.info.status.trialEnds' : 'pro.info.status.nextCharge', { date: dateLabel(stripe.nextCharge) }) }
                <br />
                <small>{ stripe.billedPlan || '—' } · { I18n.t(`pro.info.status.periodicity.${ stripe.periodicity || 'monthly' }`) }</small>
              </p>
            )
          }
        </Grid.Column>

      </Grid>

      {
        misaligned && (
          <Message warning size="tiny">
            <Icon name='warning circle' />
            { I18n.t('pro.info.status.misaligned', {
              coverage: dateLabel(coverageEnd),
              charge: dateLabel(stripe.nextCharge)
            }) }
          </Message>
        )
      }

      {
        stripe && stripe.hasSubscription && stripe.cancelAtPeriodEnd && (
          <Message warning size="tiny">
            <Icon name='warning circle' />
            { I18n.t('pro.info.status.cancelAtPeriodEnd') }
          </Message>
        )
      }

      {
        stripe && stripe.hasSubscription && stripe.scheduled && (
          <Message warning size="tiny">
            <Icon name='warning circle' />
            { I18n.t('pro.info.status.scheduled') }
          </Message>
        )
      }

    </Segment>
  );

}

export default ProLicenseStatus;
